import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { isValidE164 } from '../utils/phone';

// Reconhece os dois formatos que o InputMask brasileiro produz
const BR_MASKED_RE = /^\(\d{2}\)\d{4,5}-\d{4}$/;

/**
 * Campo de telefone com comportamento adaptado ao valor recebido do backend.
 *
 * Props:
 *  - id, onChange, placeholder: idênticos ao InputMask/InputText do PrimeReact
 *  - value:  valor armazenado no estado do pai
 *  - mask:   máscara PrimeReact ("(99)99999-9999" ou "(99)9999-9999")
 *
 * Regras de renderização:
 *  - Vazio, máscarado ou em preenchimento parcial ('_') → InputMask normal
 *  - E.164 estrangeiro (não +55)                       → InputText sem máscara
 *  - Qualquer outra coisa (lixo do banco)              → InputText com erro
 */
export function PhoneInput({ id, value, mask, placeholder, onChange }) {
    const empty = !value || value === '';
    const foreignE164 = !empty && isValidE164(value) && !value.startsWith('+55');
    const brMasked = !empty && BR_MASKED_RE.test(value);
    const partial = !empty && value.includes('_'); // usuário digitando
    const broken = !empty && !foreignE164 && !brMasked && !partial;

    if (broken) {
        return (
            <>
                <InputText
                    id={id}
                    value={value}
                    onChange={onChange}
                    className="p-invalid"
                    style={{ width: '100%' }}
                />
                <small className="p-error">
                    Telefone em formato inválido — corrija para salvar
                </small>
            </>
        );
    }

    if (foreignE164) {
        return (
            <InputText
                id={id}
                value={value}
                onChange={onChange}
                style={{ width: '100%' }}
            />
        );
    }

    return (
        <InputMask
            id={id}
            mask={mask}
            value={empty ? '' : value}
            placeholder={placeholder}
            onChange={onChange}
        />
    );
}
